import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Modal, Image } from 'react-bootstrap';
import PhotoAlbum from "react-photo-album";
import ReactGA from 'react-ga4';

const eventos = [
    {nombre: 'Constanza y Sebastián: Ceremonia Elemental (23 de octubre del 2021)', folder: '20211023', extension: '.jpg', photos: [[1, 1920, 1282], [2, 1920, 1282], [3, 1920, 1275], [4, 1920, 1275], [5, 1920, 1282], [6, 1920, 1282], [7, 1920, 1282], [8, 1920, 1282]]},
    {nombre: 'Ceremonia Elemental: Sesión de fotos (19 de marzo del 2022)', folder: '20220319', extension: '.jpg', photos: [[5, 1920, 1541], [7, 1920, 1541], [10, 1280, 1920], [17, 1920, 1280], [20, 1920, 1236], [22, 1920, 1280], [28, 1920, 1364], [29, 1920, 1280]]},
    {nombre: 'Ceremonia Éter: Sesión de fotos (15 de Marzo 2023)', folder: '20230315', extension: '.jpg', photos: [[1, 350, 525], [2, 350, 233], [3, 350, 233], [4, 350, 233], [5, 350, 233], [6, 350, 233], [7, 350, 233], [8, 350, 233]]},
    {nombre: 'Marisol y Moisés: Ceremonia Elemental (7 de octubre 2023)', folder: '20231007', extension: '.jpg', photos: [[1, 350, 481], [2, 350, 467], [3, 350, 467], [4, 350, 467], [5, 350, 263], [6, 350, 263], [7, 350, 467], [8, 350, 467]]},
    {nombre: 'Albana y Franky (10 de enero del 2025)', folder: '20250110', extension: '.jpg', photos: [[1, 350, 263], [2, 350, 467], [3, 350, 263], [4, 350, 263], [5, 350, 263], [6, 350, 467]]},
    {nombre: 'Aymara y Nicolás (31 de octubre del 2024)', folder: '20241031', extension: '.jpeg', photos: [[1, 350, 233], [2, 350, 233], [3, 350, 233], [4, 350, 233], [5, 350, 233], [6, 350, 233], [7, 350, 233]]},
    {nombre: 'Paola y Marcelo (7 de septiembre del 2024)', folder: '20240907', extension: '.jpg', photos: [[1, 350, 197], [2, 350, 197], [3, 350, 197], [4, 350, 233], [5, 350, 214], [6, 350, 197], [7, 350, 197], [8, 350, 233]]}
];

const getPhoto = (photo, folder, extension) => {
        return {
            src: process.env.PUBLIC_URL + `/imgs/galeria/${folder}/thumbs/${photo[0]}${extension}`,
            width: photo[1],
            height: photo[2],
            full: process.env.PUBLIC_URL + `/imgs/galeria/${folder}/${photo[0]}${extension}`,
        };
    }

    const addPhotosToGallery = (photoDetail, gallery, folder) => {
        photoDetail.photos.forEach((photo) => {
            gallery.push(getPhoto(photo, folder, photoDetail.extension));
        });
    }


const GalleryPage = () => {

    const [galleries, setGalleries] = useState([]);
    const shouldFetch = useRef(true);
    const [showModal, setShowModal] = useState(false);
    const [currentPhoto, setCurrentPhoto] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentGallery, setCurrentGallery] = useState(null);

    

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "Galería de Imágenes" });
        if (shouldFetch.current && galleries.length === 0) {
            shouldFetch.current = false;

            const eventosAgregar = [];
            eventos.forEach(evento => {
                const gallery = [];
                addPhotosToGallery(evento, gallery, evento.folder);
                eventosAgregar.push({nombre: evento.nombre, gallery: gallery});
            });
            setGalleries(eventosAgregar);
        }

    }, []);

    const onPhotoClick = (photo, index, evento) => {
        setShowModal(true);
        setCurrentPhoto(photo);
        setCurrentIndex(index);
        setCurrentGallery(evento.gallery);
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentPhoto(null);
        setCurrentIndex(0);
        setCurrentGallery(null);
    }

    const handleNext = () => {
        const gallery = currentGallery;
        const nextIndex = (currentIndex + 1) % gallery.length;
        setCurrentPhoto(gallery[nextIndex]);
        setCurrentIndex(nextIndex);
    }

    const handlePrev = () => {
        const gallery = currentGallery;
        const prevIndex = (currentIndex - 1 + gallery.length) % gallery.length;
        setCurrentPhoto(gallery[prevIndex]);
        setCurrentIndex(prevIndex);
    }

    return (
        <Fragment>
            <div className="section-title position-relative text-center mx-auto mb-5 mt-5 pb-3" style={{ maxWidth: '600px' }}>
                <h1 className="display-4 text-uppercase font-title">Galería</h1>
            </div>
            <div className="container-fluid">

                <div className="container">
                    {galleries.map((gallery, index) => (
                        <Fragment key={index}>
                            <h4 className='text-uppercase mt-4'>{gallery.nombre}</h4>
                            <PhotoAlbum layout="columns" photos={gallery.gallery} onClick={(event, photo, index) => onPhotoClick( photo, index, gallery)} />
                            <hr />
                        </Fragment>
                    ))}

                    <div className="row gx-5">

                    </div>
                </div>
            </div>

            <Modal size="md"  show={showModal && currentPhoto} onHide={() => handleCloseModal()} animation={false} aria-labelledby="contained-modal-title-vcenter"
                centered>
                {/* <Modal.Header closeButton>
          <Modal.Title>Matrimonio</Modal.Title>
        </Modal.Header> */}
                <Modal.Body style={{ maxHeight: '80vh'}}>
                    <Image src={currentPhoto?.full} style={{ maxWidth: '100%', maxHeight: '80vh' }} />
                    <div className="modal-prev-next">
                        <i className="bi bi-chevron-left" onClick={() => handlePrev()}></i>
                        <i className="bi bi-chevron-right" onClick={() => handleNext()}></i>
                    </div>
                </Modal.Body>
            </Modal>
        </Fragment>
    );
};

export default GalleryPage;